import { Branch, Node, Role, Unit } from '@xanadu/model';
import { RoleMenu } from './role-menu';
import { MenuBuilder } from './menu-builder';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RoleMenuBuilder extends MenuBuilder {

    public Build(node: Node, clipboard: Node): RoleMenu {
        const menu = new RoleMenu();
        if (node instanceof Unit) {
            this.forUnit(menu, node);
        } else if (node instanceof Role) {
            this.forRole(menu, node);
        }

        this.forEdit(menu, node, clipboard);

        return menu;
    }

    private forUnit(menu: RoleMenu, node: Node): void {
        if (node.isNew) {
            return;
        }

        menu.unit = true;
        menu.role = true;
    }

    private forRole(menu: RoleMenu, node: Node): void {
    }

    private forEdit(menu: RoleMenu, node: Node, clipboard: Node): void {
        menu.delete = !!node.parentId && (!(node instanceof Branch) || !node.nodes?.length && !node.branches?.length);
        menu.cut = !!node.parentId;
        menu.copy = !!node.parentId && !(node instanceof Unit);
        menu.paste = clipboard && !clipboard.childOf(node) && clipboard.fit(node as Branch) && !node.isNew;
    }
}
